export const signInRoutePath = '/users/sign_in'
export const registerRoutePath = '/users/register'
export const passwordResetRoutePath = '/users/password_reset'
export const resetPasswordConfirmationRoutePath = '/users/reset_password'
export const passwordChangeRoutePath = '/users/password_change'
export const appSignedInRoutePath = '/users/app_signed_in'
export const configurationsRoutePath = '/configurations'
export const billingRoutePath = '/billing'
export const profileRoutePath = '/profile'
export const serverEditionsRoutePath = '/server-editions'
